const SESSION_STORAGE_KEY = "collapsedMarkupCalculator";

export const useCollapsedMarkupCalculator = () => {
  const collapseCalculator = () => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(true));
  };

  const setting = sessionStorage.getItem(SESSION_STORAGE_KEY);

  const isCalculatorCollapsed = setting ? Boolean(JSON.parse(setting)) : false;

  const expandCalculator = () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  };

  return { isCalculatorCollapsed, collapseCalculator, expandCalculator };
};
